import { BASE_URL } from '@api/config';

export const getPhotoSrc = (url, isTire) => {
  return url ? `${BASE_URL}${url}` : (isTire ? '/img/no-tire-photo.png' : '/img/no-photo.png');
};
